import { PALETTE } from "../ThemeConstants";

export default function LineSeparator({
  color = PALETTE.KINDAGRAY,
  textColor = PALETTE.GRAY,
  text = "",
  marginY = 2,
  marginX = 0,
}) {
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        justifyContent: "center",
        marginTop: marginY,
        marginBottom: marginY,
        marginLeft: marginX,
        marginRight: marginX,
      }}
    >
      <div style={{ flex: 1, height: "1px", backgroundColor: color }} />
      {text !== "" && (
        <div>
          <p
            style={{
              width: "110px",
              color: textColor,
              margin: "auto",
              textAlign: "center",
            }}
          >
            {text}
          </p>
        </div>
      )}
      <div style={{ flex: 1, height: "1px", backgroundColor: color }} />
    </div>
  );
}
